(function () {
  var SECTION_SELECTOR = '.oddit-footer-main';
  var KLAVIYO_REVISION = '2024-10-15';

  function subscribeToKlaviyo(companyId, listId, email) {
    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer newsletter',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        })
      }
    ).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo subscription failed: ' + response.status);
    });
  }

  function subscribeToShopify(form) {
    return fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Shopify subscription failed: ' + response.status);
    });
  }

  function showMessage(message, type) {
    if (!message) return;
    var text = message.getAttribute(type === 'success' ? 'data-success-message' : 'data-error-message');
    message.textContent = text || '';
    message.classList.toggle('oddit-footer-main__form-message--success', type === 'success');
    message.classList.toggle('oddit-footer-main__form-message--error', type !== 'success');
    message.hidden = !text;
  }

  function initSection(section) {
    if (!section) return;
    var form = section.querySelector('.oddit-footer-main__form');
    if (!form || form.dataset.odditInit === 'true') return;
    form.dataset.odditInit = 'true';
    var message = section.querySelector('.oddit-footer-main__form-message');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('.oddit-footer-main__form-button');
      var input = form.querySelector('.oddit-footer-main__form-input');
      if (!button || !input) return;

      var email = (input.value || '').trim();
      if (!email || !input.checkValidity()) {
        input.focus();
        if (input.reportValidity) input.reportValidity();
        return;
      }

      var restWidth = button.getBoundingClientRect().width;
      button.style.minWidth = restWidth + 'px';
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      if (message) message.hidden = true;

      var companyId = (form.getAttribute('data-klaviyo-company-id') || '').trim();
      var listId = (form.getAttribute('data-klaviyo-list-id') || '').trim();
      var request = companyId && listId
        ? subscribeToKlaviyo(companyId, listId, email)
        : subscribeToShopify(form);

      request
        .then(function () {
          input.value = '';
          showMessage(message, 'success');
        })
        .catch(function () {
          showMessage(message, 'error');
        })
        .finally(function () {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          button.style.minWidth = '';
        });
    });
  }

  /* ---- Country / region selector -------------------------------------------
     Ported from the Dawn footer's localization-form, under our own element name
     so the two can coexist on the same page. */
  if (!window.customElements.get('oddit-localization-form')) {
    class OdditLocalizationForm extends HTMLElement {
      connectedCallback() {
        if (this.dataset.odditInit === 'true') return;
        this.dataset.odditInit = 'true';

        this.input = this.querySelector('input[name="country_code"]');
        this.button = this.querySelector('.oddit-footer-main__localization-button');
        this.panel = this.querySelector('.oddit-footer-main__localization-list-wrapper');
        if (!this.input || !this.button || !this.panel) return;

        this.button.addEventListener('click', () => {
          if (this.button.getAttribute('aria-expanded') === 'true') {
            this.hidePanel();
          } else {
            this.panel.removeAttribute('hidden');
            this.button.setAttribute('aria-expanded', 'true');
          }
        });

        this.addEventListener('keyup', (event) => {
          if (event.key !== 'Escape') return;
          this.hidePanel();
          this.button.focus();
        });

        this.addEventListener('focusout', (event) => {
          if (!event.relatedTarget || !this.contains(event.relatedTarget)) this.hidePanel();
        });

        this.querySelectorAll('.oddit-footer-main__localization-link').forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.input.value = link.dataset.value;
            const form = this.querySelector('form');
            if (form) form.submit();
          });
        });
      }

      hidePanel() {
        if (!this.panel) return;
        this.panel.setAttribute('hidden', '');
        this.button.setAttribute('aria-expanded', 'false');
      }
    }

    window.customElements.define('oddit-localization-form', OdditLocalizationForm);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();